import { inject } from '@angular/core';
import { Observable, combineLatest, mergeMap, take } from 'rxjs';

import { AuthService } from '@auth/services';
import { CanActivateChildFn, CanActivateFn } from '@shared/models/guard';
import { AppFacade, UserDetailsFacade } from '@shared/state/facades';

export const canActivateStateChangeGuard: CanActivateFn =
  (): Observable<boolean> => canStateChange();

export const canActivateChildStateChangeGuard: CanActivateChildFn =
  (): Observable<boolean> => canStateChange();

const canStateChange = (): Observable<boolean> => {
  const userDetailsFacade = inject(UserDetailsFacade);
  const appFacade = inject(AppFacade);
  const authService = inject(AuthService);

  return combineLatest([
    userDetailsFacade.query.userDetails$,
    appFacade.query.isAppOnline$,
    authService.authenticationResult$,
  ]).pipe(
    take(1),
    mergeMap(async ([userDetails, isAppOnline, authResult]) => {
      if (!isAppOnline && !userDetails) {
        // Logout while offline
        await authService.signinRedirect();
        return false;
      }

      if (!authResult?.idToken && !authResult?.accessToken) {
        // User isn't authenticated
        await authService.signinRedirect();
        return false;
      }

      return true;
    })
  );
};
